module.exports = __webpack_public_path__ + "img/volume.47c96854.svg";